"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgExportListCtl = /** @class */ (function (_super) {
    __extends(DlgExportListCtl, _super);
    function DlgExportListCtl() {
        return _super.call(this, true) || this;
    }
    DlgExportListCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            exportFormatCode: "CSV",
            dialogTitle: "",
            visible: false
        };
    };
    DlgExportListCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgExportListCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgExportListCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgExportListCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgExportListCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgExportListCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgExportListCtl.prototype.SetDialogTitle = function (title) {
        this.DATA.dialogTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgExportListCtl.prototype, "dialogTitle", {
        get: function () {
            return this.DATA.dialogTitle;
        },
        enumerable: true,
        configurable: true
    });
    return DlgExportListCtl;
}(BaseController_1.BaseController));
exports.DlgExportListCtl = DlgExportListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgExportList.ts
// module id = 900
// module chunks = 0